import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  disclaimer: {
    id: 'report.quickCheck.disclaimer',
    defaultMessage: 'Pikatarkastus ei kelpaa tilaajavastuulain mukaisena selvityksenä.',
    description: 'Disclaimer that the quick check is not officially valid document.',
  },
  downloadButtonLabel: {
    id: 'report.quickCheck.download.button.label',
    defaultMessage: 'Hae koko raportti tästä',
    description: 'Label for full report download button.',
  },
  downloadInfo: {
    id: 'report.quickCheck.download.info',
    defaultMessage: 'Saat tilaajavastuulain edellyttämän täydellisen raportin kirjautumalla ja lataamalla raportin.',
    description: 'Download full report info.',
  },
  statusInfo_ATTENTION: {
    id: 'report.quickCheck.interpretation.ATTENTION.info',
    defaultMessage: 'Yrityksen ilmoituksen mukaan ei velvollisuutta kuulua rekisteriin.',
    description: 'Info for RP ATTENTION-status',
  },
  statusName_ATTENTION: {
    id: 'report.quickCheck.interpretation.ATTENTION.name',
    defaultMessage: 'Huomioi',
    description: 'Name RP ATTENTION-status',
  },
  statusInfo_INCOMPLETE: {
    id: 'report.quickCheck.interpretation.INCOMPLETE.info',
    defaultMessage: 'Yrityksen tiedoista puuttuu tieto tai tietoa odotetaan tietolähteestä.',
    description: 'Info for RP INCOMPLETE-status',
  },
  statusName_INCOMPLETE: {
    id: 'report.quickCheck.interpretation.INCOMPLETE.name',
    defaultMessage: 'Tietoja odotetaan.',
    description: 'Name for RP INCOMPLETE-status',
  },
  statusInfo_INVESTIGATE: {
    id: 'report.quickCheck.interpretation.INVESTIGATE.info',
    defaultMessage: 'Tietolähteiden perusteella yrityksen tilaajavastuutiedoissa on selvitettävää!',
    description: 'Info for RP INVESTIGATE-status',
  },
  statusName_INVESTIGATE: {
    id: 'report.quickCheck.interpretation.INVESTIGATE.name',
    defaultMessage: 'Selvitä',
    description: 'Name for RP INVESTIGATE-status',
  },
  statusInfo_OK: {
    id: 'report.quickCheck.interpretation.OK.info',
    defaultMessage: 'Tietolähteiden perusteella yritys on hoitanut tilaajavastuulain edellyttämät velvoitteet.',
    description: 'Info for RP OK-status',
  },
  statusName_OK: {
    id: 'report.quickCheck.interpretation.OK.name',
    defaultMessage: 'Ok',
    description: 'Name for RP OK-status',
  },
  statusInfo_WARNING: {
    id: 'report.quickCheck.interpretation.WARNING.info',
    defaultMessage: 'Tietolähteiden perusteella yrityksen tilaajavastuutiedot eivät ole kunnossa!',
    description: 'Info for RP WARNING-status',
  },
  statusName_WARNING: {
    id: 'report.quickCheck.interpretation.WARNING.name',
    defaultMessage: 'Stop!',
    description: 'Name for RP WARNING-status',
  },
  loginButtonLabel: {
    id: 'report.quickCheck.login.button.label',
    defaultMessage: 'Kirjaudu',
    description: 'Label for login button.',
  },
  notAvailable: {
    id: 'report.quickCheck.notAvailable',
    defaultMessage: 'Yrityksen pikatarkastus ei ole saatavilla.',
    description: 'Info that company\'s quick check is not available.',
  },
  rpLogo: {
    id: 'report.quickCheck.rpLogoAlt',
    defaultMessage: 'Luotettava Kumppani',
    description: 'Alt text for RP logo.',
  },
  showLess: {
    id: 'report.quickCheck.showLess',
    defaultMessage: 'Piennnä',
    description: 'Button label to minify the view.',
  },
  showMore: {
    id: 'report.quickCheck.showMore',
    defaultMessage: 'Lue lisää',
    description: 'Button label to maximize the view.',
  },
  title: {
    id: 'report.quickCheck.title',
    defaultMessage: 'Luotettava Kumppani -pikatarkastus',
    description: 'Quick check title.',
  },
  titleShort: {
    id: 'report.quickCheck.titleShort',
    defaultMessage: 'Pikatarkastus',
    description: 'Quick check short title.',
  },
  titleStatuses: {
    id: 'report.quickCheck.titleStatuses',
    defaultMessage: 'Symbolien selitteet',
    description: 'Quick check status descriptions title.',
  },
  companyForm: {
    id: 'company.prop.companyForm',
    defaultMessage: 'Yritysmuoto',
    description: 'Label for company form',
  },
  companyHometown: {
    id: 'company.prop.hometown',
    defaultMessage: 'Kotipaikka',
    description: 'Label for company hometown',
  },
  companyIndustry: {
    id: 'company.prop.industryName',
    defaultMessage: 'Päätoimiala',
    description: 'Label for company industry name',
  }
});
